import { render, staticRenderFns } from "./airlineProductVoyageCost.vue?vue&type=template&id=a02de22a&scoped=true&"
import script from "./airlineProductVoyageCost.vue?vue&type=script&lang=js&"
export * from "./airlineProductVoyageCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02de22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a02de22a')) {
      api.createRecord('a02de22a', component.options)
    } else {
      api.reload('a02de22a', component.options)
    }
    module.hot.accept("./airlineProductVoyageCost.vue?vue&type=template&id=a02de22a&scoped=true&", function () {
      api.rerender('a02de22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost.vue"
export default component.exports